module.exports = __webpack_public_path__ + "media/icons/Overseers-30c0a7b9.svg";